/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */
import {Link, LinkProps, useLocation} from 'react-router-dom';

const LinkWithSearch = (props: LinkProps): JSX.Element => {
  const {to, children} = props;
  const {search} = useLocation();

  return <Link {...props} to={`${to}/${search || ''}`}>
    {children}
  </Link>;
};

export default LinkWithSearch;